import {Fragment} from "preact";
import {iconSuccessBadge} from "../../assets";
import { useAppContext } from "../../contexts";
import {useSuccessBadge} from "./useSuccessBadge";

/**
 * Generic success badge component that can be used throughout the whole application.
 *
 * Parameter `message` is required as it is the one responsible for controlling
 * the component's display state.
 * */
const SuccessBadge = props => {
    // Component logic data
    const componentProps = useSuccessBadge(
        {...props},
        props?.mode
    );

    // Destructured component logic data
    const {
        message,
        centered,
        rounded
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Prevents double rendering when there's a legacy calling
    if (props?.mode !== "new" && !props?.message) {
        return;
    }

    return message ? (
        <Fragment>
            <div
                className={`
                    p-3 gap-x-2 w-full h-[48px] flex flex-row items-center 
                    ${(centered ? "justify-center" : "justify-start")} ${(rounded ? "rounded-lg" : "")}
                    ${highContrast ? "grayBackground yellowBorder border-2" : "bg-[#6da544] border-0"}
                `}
            >
                <img
                    src={iconSuccessBadge}
                    className={"select-none pointer-events-none"}
                    alt="Warning icon"
                />
                <p className={"leading-none text-white font-bold text-[14px]"}>
                    {message}
                </p>
            </div>
        </Fragment>
    ) : null;
}

export default SuccessBadge;
